import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Configures the generated API clients (base URL, auth) before anything calls them.
import './lib/api-client';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
